import React, { Component } from 'react';

class SongInfo extends Component {

    constructor(props){
        super(props)

        this.state = {
            id: 0,
            title: '',
            author: '',
            image: ''
        }
    }


    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps){
            this.props = nextProps;
        }

        if (this.props.songid){
            fetch(`https://theperfectexit.net/wp-json/sgr/v1/trackdetails/${this.props.songid}`)
            .then(res => res.json())
            .then(
            (result) =>{
                this.setState({
                    'id': nextProps.songid,
                    'title': result.title,
                    'artist': result.artist,
                    'image': result.image
                });
            });
        }
    }


    render() {
        return (
          <div className="SongInfo">
            <p>Title: {this.state.title}</p>
            <p>Artist: {this.state.artist}</p>
            <img src={this.state.image} />
          </div>
        );
    }

}

export default SongInfo;